import { render, staticRenderFns } from "./Refuetype.vue?vue&type=template&id=efc7473e&scoped=true"
import script from "./Refuetype.vue?vue&type=script&lang=js"
export * from "./Refuetype.vue?vue&type=script&lang=js"
import style0 from "./Refuetype.vue?vue&type=style&index=0&id=efc7473e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc7473e",
  null
  
)

export default component.exports